import { render, staticRenderFns } from "./SingleMatchFeed.vue?vue&type=template&id=15825bec&scoped=true&"
import script from "./SingleMatchFeed.vue?vue&type=script&lang=js&"
export * from "./SingleMatchFeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15825bec",
  null
  
)

export default component.exports